import React from 'react';

import Article from '@/components/molecules/Article';
import ArticleHeader from '@/components/molecules/ArticleHeader';
import Footer from '@/components/organisms/Footer';
import Header from '@/components/organisms/Header';
import i18n from '@/translate/i18n';
import {
  Container,
  ContentWrapper,
} from '@/components/molecules/Article/styles';

function ResponsibleGaming() {
  return (
    <>
      <Header />
      <Container>
        <ArticleHeader title={i18n.t('responsibleGaming.title')} />

        <ContentWrapper>
          <Article
            textContent={i18n.t('responsibleGaming.content', {
              returnObjects: true,
            })}
          />
        </ContentWrapper>
      </Container>
      <Footer />
    </>
  );
}

export default ResponsibleGaming;
